import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateEmployeeRecordRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { updateMyEmployeeRecord } from '../api/update-my-employee-record.js';
import { meKeys } from './keys.js';

export interface UpdateMyEmployeeRecordVariables {
  data: UpdateEmployeeRecordRequestT;
}

export function useUpdateMyEmployeeRecordMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['me', 'updateEmployeeRecord'],
    mutationFn: async ({ data }: UpdateMyEmployeeRecordVariables) => {
      return await updateMyEmployeeRecord(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.status() });
    },
  });
}
